import { ExtendableError } from "@seneca/client-library";

export default class ExamQuestionBadInputError extends ExtendableError {
  constructor() {
    super("ExamQuestionBadInputError");
  }
}
